import { forwardRef } from 'react';

import { BaseBoxProps } from './type';
import StyledBox from './styled';

const Box = forwardRef<HTMLDivElement, BaseBoxProps>(({ children, ...otherProps }, ref) => {
  return (
    <StyledBox ref={ref} {...otherProps}>
      {children}
    </StyledBox>
  );
});

export default Box;
